module.exports = __webpack_public_path__ + "static/img/normal_u69.07823fef.svg";